import script from "./MovimentacoesBancariasCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./MovimentacoesBancariasCadastro.vue?vue&type=script&setup=true&lang=js"

import "./MovimentacoesBancariasCadastro.vue?vue&type=style&index=0&id=0b291576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b291576"]])

export default __exports__